// extracted by mini-css-extract-plugin
export var player = "fc-video-module--player--874ae";
export var root = "fc-video-module--root--ba339";